import { render, staticRenderFns } from "./WebsocketsDashboard.vue?vue&type=template&id=af34d056"
import script from "./WebsocketsDashboard.vue?vue&type=script&lang=js"
export * from "./WebsocketsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports